import { t } from 'i18next';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { getOrganizationSlug } from '../organizations/selectors';
import { getNetworkingOverview } from './data';
import { errorReceiveNetworkingOverview, failedReceiveNetworkingOverview, receiveNetworkingOverview } from './slice';
export function* requestNetworkingOverview() {
    try {
        const organization = yield select(getOrganizationSlug);
        const response = yield call(getNetworkingOverview, organization);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveNetworkingOverview());
        }
        else if (data && Object.keys(data).length > 0) {
            yield put(receiveNetworkingOverview(data));
        }
        else {
            throw new Error(t('NO_DATA_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveNetworkingOverview());
    }
}
export function* watchRequestNetworkingOverview() {
    yield takeLatest('networkingOverview/requestNetworkingOverview', requestNetworkingOverview);
}
